import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../api';
import { formatDate, clienteNome, Modal, ConfirmDialog, LoadingSpinner } from '../components/shared';

// ─── COSTANTI ─────────────────────────────────────────────────────────────────
const STATI_PROGETTO = [
  { key: 'APERTO',      label: 'Aperto',      pill: 'pill-blue'  },
  { key: 'IN_CORSO',    label: 'In corso',    pill: 'pill-amber' },
  { key: 'COMPLETATO',  label: 'Completato',  pill: 'pill-green' },
  { key: 'SOSPESO',     label: 'Sospeso',     pill: 'pill-gray'  },
];

const STATI_FASE = [
  { key: 'APERTA',      label: 'Aperta',      pill: 'pill-blue'  },
  { key: 'IN_CORSO',    label: 'In corso',    pill: 'pill-amber' },
  { key: 'COMPLETATA',  label: 'Completata',  pill: 'pill-green' },
  { key: 'SOSPESA',     label: 'Sospesa',     pill: 'pill-gray'  },
];

const STATI_ATTIVITA = [
  { key: 'APERTA',      label: 'Aperta',      pill: 'pill-blue'  },
  { key: 'IN_CORSO',    label: 'In corso',    pill: 'pill-amber' },
  { key: 'COMPLETATA',  label: 'Completata',  pill: 'pill-green' },
];

function statoProgettoInfo(s) { return STATI_PROGETTO.find(x => x.key === s) || { label: s, pill: 'pill-gray' }; }
function statoFaseInfo(s)     { return STATI_FASE.find(x => x.key === s)     || { label: s, pill: 'pill-gray' }; }
function statoAttInfo(s)      { return STATI_ATTIVITA.find(x => x.key === s) || { label: s, pill: 'pill-gray' }; }

// ─── FORM PROGETTO ────────────────────────────────────────────────────────────
function ProgettoForm({ initial = {}, clientiList, onSave, onClose, loading }) {
  const [d, setD] = useState({
    titolo: '', id_cliente: '', referente_aziendale: '', responsabile: '',
    descrizione: '', cartella: '', valore: '', fatturabile: 1,
    alias_email: '', stato: 'APERTO',
    data_apertura: new Date().toISOString().slice(0, 10),
    data_scadenza: '',
    ...initial,
  });
  const set = (k, v) => setD(p => ({ ...p, [k]: v }));

  return (
    <form onSubmit={e => { e.preventDefault(); onSave(d); }}>
      <div className="form-grid">

        <div className="form-group form-full">
          <label className="form-label">Titolo progetto *</label>
          <input className="form-control" value={d.titolo} onChange={e => set('titolo', e.target.value)} required />
        </div>

        <div className="form-group">
          <label className="form-label">Cliente</label>
          <select className="form-control" value={d.id_cliente} onChange={e => set('id_cliente', e.target.value)}>
            <option value="">— Nessun cliente —</option>
            {[...clientiList].sort((a, b) => (clienteNome(a) || '').localeCompare(clienteNome(b) || '', 'it'))
              .map(c => <option key={c.id} value={c.id}>{clienteNome(c)}</option>)}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Stato</label>
          <select className="form-control" value={d.stato} onChange={e => set('stato', e.target.value)}>
            {STATI_PROGETTO.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Referente aziendale</label>
          <input className="form-control" value={d.referente_aziendale || ''} onChange={e => set('referente_aziendale', e.target.value)} />
        </div>

        <div className="form-group">
          <label className="form-label">Responsabile progetto</label>
          <input className="form-control" value={d.responsabile || ''} onChange={e => set('responsabile', e.target.value)} />
        </div>

        <div className="form-group">
          <label className="form-label">Data apertura</label>
          <input className="form-control" type="date" value={d.data_apertura || ''} onChange={e => set('data_apertura', e.target.value)} />
        </div>

        <div className="form-group">
          <label className="form-label">Data scadenza</label>
          <input className="form-control" type="date" value={d.data_scadenza || ''} onChange={e => set('data_scadenza', e.target.value)} />
        </div>

        <div className="form-group form-full">
          <label className="form-label">Descrizione</label>
          <textarea className="form-control" value={d.descrizione || ''} onChange={e => set('descrizione', e.target.value)} rows={3} />
        </div>

        <div className="form-group form-full">
          <label className="form-label">Cartella archiviazione allegati</label>
          <input className="form-control" value={d.cartella || ''} onChange={e => set('cartella', e.target.value)}
            placeholder="es. /progetti/nome-cliente" />
        </div>

        <div className="form-group">
          <label className="form-label">Valore progetto (€)</label>
          <input className="form-control" type="number" step="0.01" value={d.valore || ''} onChange={e => set('valore', e.target.value)} placeholder="0.00" />
        </div>

        <div className="form-group">
          <label className="form-label">Alias e-mail progetto</label>
          <input className="form-control" type="email" value={d.alias_email || ''} onChange={e => set('alias_email', e.target.value)}
            placeholder="progetto@studio.it" />
        </div>

        <div className="form-group form-full" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <input type="checkbox" id="fatturabile" checked={!!d.fatturabile}
            onChange={e => set('fatturabile', e.target.checked ? 1 : 0)}
            style={{ width: 'auto', cursor: 'pointer' }} />
          <label htmlFor="fatturabile" className="form-label" style={{ marginBottom: 0, cursor: 'pointer' }}>Progetto fatturabile</label>
        </div>

      </div>
      <div className="modal-footer" style={{ padding: '16px 0 0', borderTop: '1px solid var(--border)', marginTop: 16 }}>
        <button type="button" className="btn" onClick={onClose}>Annulla</button>
        <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Salvataggio…' : 'Salva'}</button>
      </div>
    </form>
  );
}

// ─── FORM FASE ────────────────────────────────────────────────────────────────
function FaseForm({ initial = {}, onSave, onClose, loading }) {
  const [d, setD] = useState({ titolo: '', stato: 'APERTA', ...initial });
  const set = (k, v) => setD(p => ({ ...p, [k]: v }));
  return (
    <form onSubmit={e => { e.preventDefault(); onSave(d); }}>
      <div className="form-grid">
        <div className="form-group form-full">
          <label className="form-label">Titolo fase *</label>
          <input className="form-control" value={d.titolo} onChange={e => set('titolo', e.target.value)} required autoFocus
            placeholder="es. Analisi, Sviluppo, Test, Collaudo…" />
        </div>
        <div className="form-group form-full">
          <label className="form-label">Stato</label>
          <select className="form-control" value={d.stato} onChange={e => set('stato', e.target.value)}>
            {STATI_FASE.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
          </select>
        </div>
      </div>
      <div className="modal-footer" style={{ padding: '16px 0 0', borderTop: '1px solid var(--border)', marginTop: 16 }}>
        <button type="button" className="btn" onClick={onClose}>Annulla</button>
        <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Salvataggio…' : 'Salva'}</button>
      </div>
    </form>
  );
}

// ─── FORM ATTIVITÀ ────────────────────────────────────────────────────────────
function AttivitaFaseForm({ initial = {}, onSave, onClose, loading }) {
  const [d, setD] = useState({
    titolo: '', assegnato_a: '', stato: 'APERTA',
    data_scadenza: '', note: '',
    ...initial,
  });
  const set = (k, v) => setD(p => ({ ...p, [k]: v }));
  return (
    <form onSubmit={e => { e.preventDefault(); onSave(d); }}>
      <div className="form-grid">
        <div className="form-group form-full">
          <label className="form-label">Titolo attività *</label>
          <input className="form-control" value={d.titolo} onChange={e => set('titolo', e.target.value)} required autoFocus />
        </div>
        <div className="form-group">
          <label className="form-label">Assegnata a</label>
          <input className="form-control" value={d.assegnato_a || ''} onChange={e => set('assegnato_a', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Scadenza</label>
          <input className="form-control" type="date" value={d.data_scadenza || ''} onChange={e => set('data_scadenza', e.target.value)} />
        </div>
        <div className="form-group form-full">
          <label className="form-label">Stato</label>
          <select className="form-control" value={d.stato} onChange={e => set('stato', e.target.value)}>
            {STATI_ATTIVITA.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
          </select>
        </div>
        <div className="form-group form-full">
          <label className="form-label">Note</label>
          <textarea className="form-control" value={d.note || ''} onChange={e => set('note', e.target.value)} rows={2} />
        </div>
      </div>
      <div className="modal-footer" style={{ padding: '16px 0 0', borderTop: '1px solid var(--border)', marginTop: 16 }}>
        <button type="button" className="btn" onClick={onClose}>Annulla</button>
        <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Salvataggio…' : 'Salva'}</button>
      </div>
    </form>
  );
}

// ─── SCHEDA PROGETTO (dettaglio) ──────────────────────────────────────────────
function SchedaProgetto({ progetto, clientiList, onBack, addToast, onUpdate }) {
  const [fasi, setFasi]           = useState([]);
  const [loading, setLoading]     = useState(true);
  const [expanded, setExpanded]   = useState({});
  const [showFaseForm, setShowFaseForm]   = useState(false);
  const [editFase, setEditFase]           = useState(null);
  const [delFase, setDelFase]             = useState(null);
  const [editAtt, setEditAtt]             = useState(null);   // { faseId, att }
  const [newAttFaseId, setNewAttFaseId]   = useState(null);
  const [delAtt, setDelAtt]               = useState(null);   // { faseId, att }
  const [saving, setSaving]       = useState(false);

  const p = progetto;

  const loadFasi = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get(`/api/progetti/${p.id}/fasi`);
      setFasi(res.data || []);
      // Espandi tutte le fasi di default
      const exp = {};
      (res.data || []).forEach(f => { exp[f.id] = true; });
      setExpanded(exp);
    } catch (e) {
      addToast && addToast('Errore caricamento fasi', 'error');
    } finally {
      setLoading(false);
    }
  }, [p.id]);

  useEffect(() => { loadFasi(); }, [loadFasi]);

  const toggleFase = (id) => setExpanded(e => ({ ...e, [id]: !e[id] }));

  // FASE — salva (crea o modifica)
  const handleSalvaFase = async (d) => {
    setSaving(true);
    try {
      if (editFase?.id) {
        await api.put(`/api/fasi/${editFase.id}`, d);
        addToast && addToast('Fase aggiornata');
      } else {
        await api.post(`/api/progetti/${p.id}/fasi`, d);
        addToast && addToast('Fase creata');
      }
      setShowFaseForm(false); setEditFase(null);
      loadFasi();
    } catch (e) {
      addToast && addToast('Errore salvataggio fase', 'error');
    } finally { setSaving(false); }
  };

  const handleEliminaFase = async () => {
    if (!delFase) return;
    try {
      await api.delete(`/api/fasi/${delFase.id}`);
      addToast && addToast('Fase eliminata');
      setDelFase(null); loadFasi();
    } catch (e) {
      addToast && addToast('Errore eliminazione fase', 'error');
    }
  };

  // ATTIVITÀ — salva
  const handleSalvaAtt = async (d) => {
    setSaving(true);
    try {
      if (editAtt?.att?.id) {
        await api.put(`/api/attivita-fase/${editAtt.att.id}`, d);
        addToast && addToast('Attività aggiornata');
        setEditAtt(null);
      } else {
        await api.post(`/api/fasi/${newAttFaseId}/attivita`, d);
        addToast && addToast('Attività aggiunta');
        setNewAttFaseId(null);
      }
      loadFasi();
    } catch (e) {
      addToast && addToast('Errore salvataggio attività', 'error');
    } finally { setSaving(false); }
  };

  const handleToggleAtt = async (att) => {
    const nuovoStato = att.stato === 'COMPLETATA' ? 'APERTA' : 'COMPLETATA';
    try {
      await api.put(`/api/attivita-fase/${att.id}`, { ...att, stato: nuovoStato });
      loadFasi();
    } catch (e) {
      addToast && addToast('Errore aggiornamento', 'error');
    }
  };

  const handleEliminaAtt = async () => {
    if (!delAtt) return;
    try {
      await api.delete(`/api/attivita-fase/${delAtt.att.id}`);
      addToast && addToast('Attività eliminata');
      setDelAtt(null); loadFasi();
    } catch (e) {
      addToast && addToast('Errore eliminazione', 'error');
    }
  };

  const si = statoProgettoInfo(p.stato);
  const clienteLabel = (() => {
    if (p.denominazione || p.ragione_sociale || p.nome) {
      return p.denominazione || p.ragione_sociale || [p.nome, p.cognome].filter(Boolean).join(' ');
    }
    return '—';
  })();

  return (
    <div>
      {/* Breadcrumb */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20 }}>
        <button className="btn btn-sm" onClick={onBack}>← Progetti</button>
        <span style={{ color: 'var(--text-faint)', fontSize: 13 }}>Progetti /</span>
        <span style={{ fontSize: 13, fontWeight: 500 }}>{p.titolo}</span>
      </div>

      {/* Header progetto */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
          <div>
            <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 4 }}>{p.titolo}</h2>
            {p.alias_email && (
              <span style={{ fontSize: 12, color: 'var(--accent)', fontFamily: 'monospace' }}>✉ {p.alias_email}</span>
            )}
          </div>
          <span className={`pill ${si.pill}`}>{si.label}</span>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px 24px', fontSize: 13 }}>
          <InfoRow label="Cliente"           value={clienteLabel} />
          <InfoRow label="Referente az."     value={p.referente_aziendale} />
          <InfoRow label="Responsabile"      value={p.responsabile} />
          <InfoRow label="Apertura"          value={formatDate(p.data_apertura)} />
          <InfoRow label="Scadenza"          value={formatDate(p.data_scadenza)} />
          <InfoRow label="Fatturabile"       value={p.fatturabile ? 'Sì' : 'No'} />
          {p.valore ? <InfoRow label="Valore" value={`€ ${parseFloat(p.valore).toLocaleString('it-IT', { minimumFractionDigits: 2 })}`} /> : null}
          {p.cartella ? <InfoRow label="Cartella" value={p.cartella} mono /> : null}
        </div>

        {p.descrizione && (
          <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid var(--border)', fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            {p.descrizione}
          </div>
        )}
      </div>

      {/* Fasi e attività */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div>
          <span style={{ fontWeight: 600, fontSize: 15 }}>Fasi e attività</span>
          <span style={{ marginLeft: 8, fontSize: 12, color: 'var(--text-faint)' }}>{fasi.length} fasi</span>
        </div>
        <button className="btn btn-primary btn-sm" onClick={() => { setEditFase(null); setShowFaseForm(true); }}>
          + Nuova fase
        </button>
      </div>

      {loading ? <LoadingSpinner /> : (
        fasi.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">📋</div>
            <div className="empty-state-title">Nessuna fase</div>
            <div style={{ fontSize: 13, color: 'var(--text-faint)', marginTop: 4 }}>
              Aggiungi la prima fase per strutturare il progetto
            </div>
          </div>
        ) : (
          fasi.map(fase => {
            const fsi = statoFaseInfo(fase.stato);
            const isOpen = expanded[fase.id] !== false;
            const attività = fase.attivita || [];
            const completate = attività.filter(a => a.stato === 'COMPLETATA').length;

            return (
              <div key={fase.id} className="card" style={{ marginBottom: 10, padding: 0, overflow: 'hidden' }}>
                {/* Header fase */}
                <div style={{
                  display: 'flex', alignItems: 'center', gap: 10,
                  padding: '10px 14px', background: 'var(--surface-alt, var(--surface))',
                  borderBottom: isOpen ? '1px solid var(--border)' : 'none',
                  cursor: 'pointer',
                }} onClick={() => toggleFase(fase.id)}>
                  <span style={{ fontSize: 11, color: 'var(--text-faint)', userSelect: 'none' }}>{isOpen ? '▼' : '▶'}</span>
                  <span style={{ fontWeight: 600, fontSize: 13, flex: 1 }}>{fase.titolo}</span>
                  <span style={{ fontSize: 11, color: 'var(--text-faint)' }}>
                    {completate}/{attività.length} attività
                  </span>
                  <span className={`pill ${fsi.pill}`} style={{ fontSize: 11 }}>{fsi.label}</span>
                  <button className="btn btn-sm btn-icon" title="Modifica fase"
                    onClick={e => { e.stopPropagation(); setEditFase(fase); setShowFaseForm(true); }}>✎</button>
                  <button className="btn btn-sm btn-danger btn-icon" title="Elimina fase"
                    onClick={e => { e.stopPropagation(); setDelFase(fase); }}>×</button>
                </div>

                {/* Corpo fase */}
                {isOpen && (
                  <div style={{ padding: '10px 14px' }}>
                    {attività.length === 0 && (
                      <div style={{ fontSize: 12, color: 'var(--text-faint)', marginBottom: 10 }}>
                        Nessuna attività in questa fase.
                      </div>
                    )}
                    {attività.map(att => {
                      const asi = statoAttInfo(att.stato);
                      return (
                        <div key={att.id} style={{
                          display: 'flex', alignItems: 'center', gap: 10,
                          padding: '7px 0', borderBottom: '1px solid var(--border)',
                        }}>
                          <input type="checkbox" checked={att.stato === 'COMPLETATA'}
                            onChange={() => handleToggleAtt(att)}
                            style={{ width: 'auto', cursor: 'pointer', flexShrink: 0 }} />
                          <span style={{
                            flex: 1, fontSize: 13,
                            textDecoration: att.stato === 'COMPLETATA' ? 'line-through' : 'none',
                            color: att.stato === 'COMPLETATA' ? 'var(--text-faint)' : 'inherit',
                          }}>{att.titolo}</span>
                          {att.assegnato_a && (
                            <span style={{ fontSize: 11, color: 'var(--text-faint)', whiteSpace: 'nowrap' }}>
                              👤 {att.assegnato_a}
                            </span>
                          )}
                          {att.data_scadenza && (
                            <span style={{ fontSize: 11, color: 'var(--text-faint)', whiteSpace: 'nowrap' }}>
                              📅 {formatDate(att.data_scadenza)}
                            </span>
                          )}
                          <span className={`pill ${asi.pill}`} style={{ fontSize: 11 }}>{asi.label}</span>
                          <button className="btn btn-sm btn-icon" title="Modifica"
                            onClick={() => setEditAtt({ faseId: fase.id, att })}>✎</button>
                          <button className="btn btn-sm btn-danger btn-icon" title="Elimina"
                            onClick={() => setDelAtt({ faseId: fase.id, att })}>×</button>
                        </div>
                      );
                    })}

                    {/* Aggiungi attività inline */}
                    <div style={{ marginTop: 10 }}>
                      <button className="btn btn-sm" onClick={() => setNewAttFaseId(fase.id)}>
                        + Aggiungi attività
                      </button>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        )
      )}

      {/* Modali */}
      {showFaseForm && (
        <Modal title={editFase?.id ? 'Modifica fase' : 'Nuova fase'} onClose={() => { setShowFaseForm(false); setEditFase(null); }}>
          <FaseForm initial={editFase || {}} onSave={handleSalvaFase} onClose={() => { setShowFaseForm(false); setEditFase(null); }} loading={saving} />
        </Modal>
      )}

      {newAttFaseId && (
        <Modal title="Nuova attività" onClose={() => setNewAttFaseId(null)}>
          <AttivitaFaseForm initial={{}} onSave={handleSalvaAtt} onClose={() => setNewAttFaseId(null)} loading={saving} />
        </Modal>
      )}

      {editAtt && (
        <Modal title="Modifica attività" onClose={() => setEditAtt(null)}>
          <AttivitaFaseForm initial={editAtt.att} onSave={handleSalvaAtt} onClose={() => setEditAtt(null)} loading={saving} />
        </Modal>
      )}

      {delFase && (
        <ConfirmDialog
          message={`Eliminare la fase "${delFase.titolo}" e tutte le sue attività?`}
          onConfirm={handleEliminaFase}
          onCancel={() => setDelFase(null)} />
      )}

      {delAtt && (
        <ConfirmDialog
          message={`Eliminare l'attività "${delAtt.att.titolo}"?`}
          onConfirm={handleEliminaAtt}
          onCancel={() => setDelAtt(null)} />
      )}
    </div>
  );
}

// Helper riga info
function InfoRow({ label, value, mono }) {
  if (!value) return null;
  return (
    <div>
      <span style={{ color: 'var(--text-faint)', fontSize: 12 }}>{label}</span>
      <div style={{ fontWeight: 500, fontFamily: mono ? 'monospace' : 'inherit', fontSize: 12, marginTop: 1 }}>{value}</div>
    </div>
  );
}

// ─── MAIN ─────────────────────────────────────────────────────────────────────
export default function Progetti({ addToast }) {
  const [rows, setRows]           = useState([]);
  const [clienti, setClienti]     = useState([]);
  const [loading, setLoading]     = useState(true);
  const [q, setQ]                 = useState('');
  const [filtroStato, setFiltroStato] = useState('');
  const [showForm, setShowForm]   = useState(false);
  const [editItem, setEditItem]   = useState(null);
  const [delItem, setDelItem]     = useState(null);
  const [saving, setSaving]       = useState(false);
  const [dettaglio, setDettaglio] = useState(null); // progetto selezionato

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [pRes, cRes] = await Promise.all([
        api.get('/api/progetti'),
        api.getClienti({ limit: 300 }),
      ]);
      setRows(pRes.data || []);
      setClienti(cRes.rows || []);
    } catch (e) {
      addToast && addToast('Errore caricamento progetti', 'error');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const filtered = rows.filter(r => {
    const txt = q.toLowerCase();
    const matchQ = !txt || r.titolo?.toLowerCase().includes(txt)
      || r.denominazione?.toLowerCase().includes(txt)
      || r.ragione_sociale?.toLowerCase().includes(txt)
      || r.responsabile?.toLowerCase().includes(txt);
    const matchStato = !filtroStato || r.stato === filtroStato;
    return matchQ && matchStato;
  });

  const stats = {
    aperti:     rows.filter(r => r.stato === 'APERTO').length,
    inCorso:    rows.filter(r => r.stato === 'IN_CORSO').length,
    completati: rows.filter(r => r.stato === 'COMPLETATO').length,
  };

  const handleSalva = async (d) => {
    setSaving(true);
    try {
      if (editItem?.id) {
        await api.put(`/api/progetti/${editItem.id}`, d);
        addToast && addToast('Progetto aggiornato');
      } else {
        await api.post('/api/progetti', d);
        addToast && addToast('Progetto creato');
      }
      setShowForm(false); setEditItem(null);
      load();
    } catch (e) {
      addToast && addToast('Errore salvataggio', 'error');
    } finally { setSaving(false); }
  };

  const handleElimina = async () => {
    if (!delItem) return;
    try {
      await api.delete(`/api/progetti/${delItem.id}`);
      addToast && addToast('Progetto eliminato');
      setDelItem(null); load();
    } catch (e) {
      addToast && addToast('Errore eliminazione', 'error');
    }
  };

  // Vista dettaglio
  if (dettaglio) {
    return (
      <SchedaProgetto
        progetto={dettaglio}
        clientiList={clienti}
        onBack={() => { setDettaglio(null); load(); }}
        addToast={addToast}
        onUpdate={(p) => setDettaglio(p)}
      />
    );
  }

  // Vista lista
  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Progetti</div>
          <div className="page-subtitle">{filtered.length} progetto{filtered.length !== 1 ? 'i' : ''}</div>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <div className="search-box" style={{ width: 200 }}>
            <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
              <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.5" />
              <path d="M11 11l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
            <input placeholder="Cerca…" value={q} onChange={e => setQ(e.target.value)} />
          </div>
          <select className="form-control" style={{ width: 130 }} value={filtroStato} onChange={e => setFiltroStato(e.target.value)}>
            <option value="">Tutti gli stati</option>
            {STATI_PROGETTO.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
          </select>
          <button className="btn btn-primary" onClick={() => { setEditItem(null); setShowForm(true); }}>+ Nuovo</button>
        </div>
      </div>

      {/* KPI */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 20 }}>
        {[
          ['Aperti',     stats.aperti,     'var(--c-blue)'],
          ['In corso',   stats.inCorso,    'var(--c-amber)'],
          ['Completati', stats.completati, 'var(--c-green)'],
        ].map(([l, v, c]) => (
          <div key={l} className="kpi-card">
            <div className="kpi-accent" style={{ background: c }} />
            <div className="kpi-label">{l}</div>
            <div className="kpi-value">{v}</div>
          </div>
        ))}
      </div>

      {loading ? <LoadingSpinner /> : (
        <div className="card">
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Progetto</th>
                  <th>Cliente</th>
                  <th>Responsabile</th>
                  <th>Apertura</th>
                  <th>Scadenza</th>
                  <th>Stato</th>
                  <th>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(p => {
                  const si = statoProgettoInfo(p.stato);
                  const clienteLabel = p.denominazione || p.ragione_sociale || [p.nome, p.cognome].filter(Boolean).join(' ') || '—';
                  return (
                    <tr key={p.id}>
                      <td>
                        <span className="fw-500" style={{ cursor: 'pointer', color: 'var(--accent)' }}
                          onClick={() => setDettaglio(p)}>{p.titolo}</span>
                        {p.fatturabile ? <span style={{ marginLeft: 6, fontSize: 10, color: 'var(--c-green)' }}>€</span> : null}
                      </td>
                      <td style={{ fontSize: 12 }}>{clienteLabel}</td>
                      <td style={{ fontSize: 12 }}>{p.responsabile || '—'}</td>
                      <td style={{ fontSize: 12 }}>{p.data_apertura ? formatDate(p.data_apertura) : '—'}</td>
                      <td style={{ fontSize: 12 }}>{p.data_scadenza ? formatDate(p.data_scadenza) : '—'}</td>
                      <td><span className={`pill ${si.pill}`} style={{ fontSize: 11 }}>{si.label}</span></td>
                      <td>
                        <div style={{ display: 'flex', gap: 4 }}>
                          <button className="btn btn-sm btn-icon" title="Apri scheda" onClick={() => setDettaglio(p)}>🗂</button>
                          <button className="btn btn-sm btn-icon" title="Modifica" onClick={() => { setEditItem(p); setShowForm(true); }}>✎</button>
                          <button className="btn btn-sm btn-danger btn-icon" title="Elimina" onClick={() => setDelItem(p)}>×</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
                {filtered.length === 0 && (
                  <tr><td colSpan={7}>
                    <div className="empty-state">
                      <div className="empty-state-icon">📁</div>
                      <div className="empty-state-title">Nessun progetto trovato</div>
                    </div>
                  </td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Modali */}
      {(showForm || editItem) && (
        <Modal title={editItem ? 'Modifica progetto' : 'Nuovo progetto'}
          onClose={() => { setShowForm(false); setEditItem(null); }}>
          <ProgettoForm initial={editItem || {}} clientiList={clienti}
            onSave={handleSalva} onClose={() => { setShowForm(false); setEditItem(null); }} loading={saving} />
        </Modal>
      )}

      {delItem && (
        <ConfirmDialog
          message={`Eliminare il progetto "${delItem.titolo}"? Verranno eliminate anche tutte le fasi e attività associate.`}
          onConfirm={handleElimina}
          onCancel={() => setDelItem(null)} />
      )}
    </div>
  );
}
